import {
  LOAD_COMPONENTS,
  CREATE_COMPONENT,
  UPDATE_COMPONENT,
  DELETE_COMPONENT,
  OPEN_COMPONENT,
  COMPONENT_IMPORT_STATUS,
  LOAD_COMPONENT_TYPE,
  LOAD_COMPONENT_PAGES,
  LOADING_COMPONENTS,
  LOAD_COMPONENT_HISTORY,
  SET_ASSET_HEALTH_FILTER_FIELD_DATA_QUERY,
} from '../actions/componentActions';

const initialState = {
  components: [],
  selectedComponent: [],
  componentImportStatus: {},
  component_types: {},
  componentPages:[],
  currentPage: 1,
  totalPage: 3,
  pendingComponentCount: 0,
  historyReport:'',
  assetsHealthFilterFieldData:'',
  loadingComponent: true,
};

export default ( state = initialState, action ) => {
  switch (action.type) {
    case LOAD_COMPONENTS: {
      const fetchedComponentsData =
        action.payload.filter(
          componentsData =>
            componentsData.updated_health_status =
              componentsData.health_status &&
              componentsData.health_status.status &&
              componentsData.health_status.severity
                ? componentsData.health_status.status + '/' + componentsData.health_status.severity
                : ''
        );
      return {
        ...state,
        components: fetchedComponentsData,
      };
    }

    case LOAD_COMPONENT_PAGES:
        console.log("Load Component API total_pages: ");
        console.log(action.payload.total_pages);
        console.log("Current Page: ");
        console.log(action.payload.page);
        let component_list = [];
        if(action.payload.paginationType && action.payload.paginationType === 'normal_pagination') {
          component_list=action.payload.data
        } else {
          if(!action.payload.page || action.payload.page==0){
            component_list=[];
          } else if(action.payload.page>1){
            component_list=state.componentPages.concat(action.payload.data);
          } else{
            component_list=action.payload.data
          }
        }

        let pending_count=null;
        if (action.payload.pending_count){
            pending_count = action.payload.pending_count;
        } else {
            pending_count=state.pendingComponentCount;
        }
        return {
            ...state,
            componentPages: component_list,
            currentPage: action.payload.page,
            pendingComponentCount: pending_count,
            totalPage: action.payload.total_pages,
            loadingComponent:false
        };

    case CREATE_COMPONENT:
      return {
        ...state,
        components: [...state.components, action.payload],
      };

    case LOADING_COMPONENTS:
       return {
            ...state,
            loadingComponent:action.payload
        };

    case UPDATE_COMPONENT:
      const updatedComponents =
        state.components.filter(component => component._id !== action.payload._id);

      return {
        ...state,
        components: [...updatedComponents, action.payload],
      };

    case DELETE_COMPONENT:
      const filteredComponent =
        state.components.filter(component => component._id !== action.payload);

      return {
        ...state,
        components: filteredComponent,
      };

    case OPEN_COMPONENT:
      return {
        ...state,
        selectedComponent: action.payload,
      };

    case COMPONENT_IMPORT_STATUS:
      return {
        ...state,
        componentImportStatus: action.payload,
      };

    case LOAD_COMPONENT_TYPE:
      return {
        ...state,
        component_types: action.payload,
      };

    case LOAD_COMPONENT_HISTORY:
      console.log("Component history data: ");
      console.log(action.payload);

      return {
        ...state,
        historyReport: action.payload,
      };

    case SET_ASSET_HEALTH_FILTER_FIELD_DATA_QUERY:
      return {
        ...state,
        assetsHealthFilterFieldData: action.payload
      };

    default:
      return { ...state };
  }

};
